import type { SizeGuideEntry, SizeGuideList } from '../../types/SizeGuide.types'

export interface SizeGuideTableLayout {
	headers: string[]
	body: SizeGuideEntry[][]
}

export interface ParsedSizeGuides {
	sizeGuides: SizeGuideTableLayout[]
	name?: string
}

export const parseSizeGuide = (data: SizeGuideList[]): ParsedSizeGuides[] =>
	data.map(({ name, sizeGuides }) => ({
		name,
		sizeGuides: sizeGuides.map((sizeGuideElement) =>
			Object.keys(sizeGuideElement).reduce<SizeGuideTableLayout>(
				(parsedTable, column, columnIndex) => {
					parsedTable.headers.push(column)

					sizeGuideElement[column].forEach((element, index) => {
						if (columnIndex === 0) {
							parsedTable.body.push([element])
						} else {
							parsedTable.body[index].push(element)
						}
					})

					return parsedTable
				},
				{ headers: [], body: [] }
			)
		),
	}))
